<template>
    <div class="card card-pdv card-work-schedule-statement-chart">
        <PageHeader :title="i18nVisitsBookedVsCarriedOut" />
        <div class="card-body">
            <column-chart
                :categories-series-prop="categories"
                :series-prop="series"
                :hide-legend="false"
                :busy="loading"
                :colors-prop="['#3498db', '#85c1e9']"
                :yaxis-config="yaxisConfig"
                data-labels-position="center"
            />
        </div>
    </div>
</template>

<script>
    import WorkScheduleStatementService from '@/src/services/dashboards/widgets/WorkScheduleStatementService'
    import { computeYAxisScaleFromSeries } from '@/src/utils/chart-scale'
    import PageHeader from '@/src/components/PageHeader.vue'
    import ColumnChart from '@/src/components/charts/ColumnChart.vue'
    import swalFeedback from '@src/mixins/swalFeedback.vue'
    import validationMixin from '@src/mixins/validation.vue'
    const i18nKey = 'DASHBOARDS'

    export default {
        components: {
            PageHeader,
            ColumnChart,
        },
        mixins: [
            validationMixin,
            swalFeedback,
        ],
        props: {
            busy: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                i18nKey,
                loading: false,
                series: [],
                categories: [],
                yaxisConfig: {
                    min: 0,
                    max: 10,
                    tickAmount: 5,
                    forceNiceScale: true,
                },
            }
        },
        validations: {},
        computed: {
            i18nVisitsBookedVsCarriedOut() {
                return this.getI18n(i18nKey, 'TITLES.visits_booked_vs_carried_out')
            },
        },
        methods: {
            refresh(parameters) {
                this.loading = true
                this.series = []
                this.categories = []

                WorkScheduleStatementService.perType(parameters)
                    .then((response) => {
                        const data = response.data.data || {}
                        this.categories = data.categories || []
                        this.series = Array.isArray(data.series) ? data.series : []
                        this.yaxisConfig = computeYAxisScaleFromSeries(this.series)

                        this.loading = false
                    })
                    .catch((err) => {
                        this.loading = false
                        return err
                    })
            },
        },
    }
</script>


<style>
    .card-work-schedule-statement-chart h4 {
        font-weight: 600 !important;
        text-align: left !important;
    }
</style>
